<template>
   <div>
      <div class="center">
         <img src="../assets/images/not.png" alt="">
         <br>
         <h3>哎呀，你要找的页面丢失了</h3>
         <span>你要查看的网页可能已被删除、名称已被更改或暂时不可用</span>
      </div>
      <div class="anniu">
            <el-row>
                <el-button class="fanhui" style="margin-right:10px" @click="goback">返回</el-button>
                <el-button class="shuxin" @click="refresh">刷新</el-button>
            </el-row>
        </div>
   </div>
</template>

<script>
export default {
   methods: {
      goback(){
         this.$router.go(-1)
      },
      refresh(){
         this.$router.go(0)
      }
   },
   data(){
      return {

      }
   }
}
</script>

<style scoped>
   .center{
      padding-left: 30%;
      padding-top:10%;

   }
   .anniu{
      padding-top: 20px;
   }
   .anniu{
      text-align: center;
   }
   h3{
      padding-left: 20%;
      padding-top: 7%;
      padding-bottom: 1%;
      color:rgb(85, 85, 85);
   }
   span{
      font-size: 15px;
      color: rgb(139, 138, 138);
      padding-left: 10%;
      font-weight: 40px;
   }
   .fanhui{
      padding: 12px 35px;
      border: 1px solid rgb(184, 184, 184);
   }
   .shuxin {
      background-color: #006aca;
      color: white;
      padding: 12px 35px;
   }
</style>
